/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCapexDto } from '../../models/backend-actual-capex-dto';
import { BackendActualCapexRequestDto } from '../../models/backend-actual-capex-request-dto';

export interface MonitoringActualsCapexsCreate$FormData$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualCapexRequestDto;
}

export function monitoringActualsCapexsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCapexsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCapexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCapexsCreate$FormData.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCapexDto>;
    }),
  );
}

monitoringActualsCapexsCreate$FormData.PATH = '/api/monitoring/actuals/capexs/';
